import React from 'react';
import { connect } from "react-redux";
import { withSnackbar } from 'notistack';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import DataGrid, { Button, Column, SearchPanel, StateStoring, Export, ColumnChooser, ColumnFixing, Editing, HeaderFilter, Summary, TotalItem, Scrolling, Toolbar, Item as ToolbarItem, Selection, FilterPanel } from 'devextreme-react/data-grid';
import { FormattedMessage, injectIntl } from "react-intl";
import moment from 'moment';
import { custom as CustomDialog } from 'devextreme/ui/dialog';
import { exportDataGrid } from 'devextreme/excel_exporter';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import ContractActionCreateModal, { RESPONSES as CreateModalResponses } from './Helpers/ContractActionCreateModal';
import ContractActionEditModal, { RESPONSES as EditModalResponses } from './Helpers/ContractActionEditModal';
import ContractActionExcelHelper from "./Helpers/ContractActionExcelHelper";
import * as actionCrud from '../../../../crud/action.crud';
import { listAccountsAllowedDeleteCompletedAction } from '../../../../router/Protector/AccessExceptions';
import { Link } from "react-router-dom";
import { getActionGroupCategories } from '../../../../shared/lookup';
import { Switch } from 'devextreme-react';
import * as utils from "../../../../../_metronic/utils/utils";
import { withRouter } from '../../../../shared/hoc/withRouter';
import SystemHelper from "../../../../shared/systemHelper";

const customFilterStorageKey = "FD-ContractActionsCustomFilter2";
const customFilterStoragePeriod = 14 * 24 * 60 * 60; // default: seconds for 14 day
export const completeActionConfirmationDialog = (actionItem, intl) => {
    return new Promise(async (resolve, reject) => {
        try {
            let message = intl.formatMessage({ id: "ACTIONS.POPUP.COMPLETE.MESSAGE" }) + "<br/>";
            if (actionItem.sourcereferenceid) {
                message += "<br/><strong>" + intl.formatMessage({ id: "ACTIONS.FIELD.CREATE_BY_REFERENCE" }) + " : </strong>" + actionItem.sourcereferenceid;
            }
            if (actionItem.subject) {
                message += "<br/><strong>" + intl.formatMessage({ id: "ACTIONS.FIELD.SUBJECT" }) + " : </strong>" + actionItem.subject;
            }
            if (actionItem.duedate) {
                message += "<br/><strong>" + intl.formatMessage({ id: "ACTIONS.FIELD.DUE_DATE" }) + " : </strong>" + moment(actionItem.duedate).format('DD/MM/YYYY');
            }

            let activateDialog = CustomDialog({
                title: intl.formatMessage({ id: "ACTIONS.POPUP.COMPLETE.TITLE" }),
                messageHtml: `<div style="max-width:60vw;">${message}</div>`,
                buttons: [
                    {
                        text: intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_CANCEL" }),
                        onClick: (e) => { return "CANCEL" }
                    },
                    {
                        text: intl.formatMessage({ id: "ACTIONS.FIELD.COMPLETE" }),
                        type: "success",
                        stylingMode: "outlined",
                        onClick: (e) => { return "CONTINUE" }
                    }
                ]
            });
            const result = await activateDialog.show();
            if (result === "CONTINUE") {
                resolve(true);
            }
            else{
                resolve(false)
            }
        }
        catch (err) {
            reject(err)
        }
    });
}


class ContractActions extends React.Component {
    constructor(props) {
        super(props);
        this.allowEdit = this.props.protectedRouteProps.allowEdit;
        this.gridRef = React.createRef();
        this.fileImportInputRef = React.createRef();
        this.importExcelTemplateDownloadLinkRef = React.createRef();
        this.actionGroupCategories = getActionGroupCategories(this.props.intl);

        const localStorateFilters = utils.getStorage(customFilterStorageKey);
        let customFilter = localStorateFilters
            ? JSON.parse(localStorateFilters)
            : {
                includeCompleted: false,
                includeDeleted: false,
                includeArchived: false
            };

        this.additionalColumns = [
            {
                caption: this.props.intl.formatMessage({ id: "GENERAL.FORMS.FIELD.SOURCELINK" }),
                dataField: "url",
                showInColumnChooser: false,
                showInExport: true
            },
            {
                caption: this.props.intl.formatMessage({ id: "ACTIONS.FIELD.DELETE_ACTION" }),
                dataField: "delete",
                showInColumnChooser: false,
                showInExport: true
            },
            {
                caption: this.props.intl.formatMessage({ id: "ACTIONS.FIELD.COMPLETE_ACTION" }),
                dataField: "complete",
                showInColumnChooser: false,
                showInExport: true
            },
            {
                caption: this.props.intl.formatMessage({ id: "ACTIONS.FIELD.EDIT_ACTION" }),
                dataField: "edit",
                showInColumnChooser: false,
                showInExport: true
            },
        ];

        this.state = {
            isBusy: true,
            actions: null,
            showAddActionModal: false,
            showEditActionModal: false,
            editingAction: null,
            customFilter
        }
    }

    componentDidMount() {
        const { location } = this.props;
        const searchParams = new URLSearchParams(location.search);

        this.loadActions(searchParams);

        utils.setStorage(
            customFilterStorageKey,
            JSON.stringify(this.state.customFilter),
            customFilterStoragePeriod
        );
    }
    componentDidUpdate(prevProps, prevState) {

    }

    loadActions = async (searchParams) => {
        this.setState({ isBusy: true }, async () => {
            try {
                const { data: actions } = await actionCrud.getRegisterList(
                    this.props.contract.contractid,
                    this.state.customFilter.includeCompleted,
                    this.state.customFilter.includeArchived,
                    this.state.customFilter.includeDeleted,
                    this.props.contractTemplate.accessibleWfIds
                );
                this.setState({ actions, isBusy: false }, async () => {
                    if (searchParams?.toString()) {
                        const action = searchParams.get('action');
                        const actionId = searchParams.get('actionid');

                        const actionData = actions.find(c => c.actionid == actionId);

                        if (actionData) {
                            switch (action) {
                                case 'complete':
                                    const invalidCompleteItem = !this.validateComplete(actionData).allowed;
    
                                    if (invalidCompleteItem) {
                                        this.props.enqueueSnackbar(this.validateComplete(invalidCompleteItem).error, { variant: "error" });
                                        return;
                                    } else {
                                        this.completeActionFromLink(actionData);
                                    }
                                    break;
                                case 'delete':
                                    const invalidDeleteItem = !this.validateDelete(actionData).allowed;
    
                                    if (invalidDeleteItem) {
                                        this.props.enqueueSnackbar(this.validateDelete(invalidDeleteItem).error, { variant: "error" });
                                        return;
                                    } else {
                                        let activateDialog = CustomDialog({
                                            title: this.props.intl.formatMessage({ id: 'ACTIONS.POPUP.BATCH_DELETE.TITLE' }, { COUNT: 1 }),
                                            messageHtml: `<div style="max-width:60vw;">${this.props.intl.formatMessage({ id: 'ACTIONS.POPUP.BATCH_DELETE.MESSAGE' }, { COUNT: 1 })}</div>`,
                                            buttons: [
                                                {
                                                    text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_CANCEL" }),
                                                    onClick: (e) => { return "CANCEL" }
                                                },
                                                {
                                                    text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_DELETE" }),
                                                    type: "danger",
                                                    stylingMode: "outlined",
                                                    onClick: (e) => { return "CONTINUE" }
                                                }
                                            ]
                                        });
                    
                                        const result = await activateDialog.show();
                                        if (result === "CONTINUE") {
                                            const formData = {
                                                actionids: [Number(actionId)],
                                                contractid: this.props.contract.contractid
                                            };
                                            this.setState({ isBusy: true }, async () => {
                                                try {
                                                    await actionCrud.deleteAction(formData);
                                                    this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "ACTIONS.TOAST.ACTIONS_DELETED" }), { variant: "success" });
                                                    this.gridRef.current.instance().clearSelection();
                                                    this.loadActions();
                                                }
                                                catch (err) {
                                                    this.setState({ isBusy: false })
                                                    this.props.enqueueSnackbar(err.toString(), { variant: "error" });
                                                }
                                            })
                            
                                        }
                                    }
                                    break;
                                case 'edit':
                                    const invalidEditItem = !this.validateEdit(actionData).allowed;
    
                                    if (invalidEditItem) {
                                        this.props.enqueueSnackbar(this.validateEdit(invalidEditItem).error, { variant: "error" });
                                        return;
                                    } else {
                                        this.setState({ editingAction: { ...actionData }, showEditActionModal: true });
                                    }
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                });
            } catch (err) {
                this.setState({ actions: null, isBusy: false });
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            }
        })
    }

    regenerateSystemActions = async () => {
        let activateDialog = CustomDialog({
            title: "Delete & Regenerate System Actions",
            messageHtml: `<div style="max-width:60vw;">This process will delete all system generated action history for this contract and regenerate pending actions for current state only. Are you sure you want to continue?</div>`,
            buttons: [
                {
                    text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_CANCEL" }),
                    onClick: (e) => { return "CANCEL" }
                },
                {
                    text: "Regenerate",
                    type: "danger",
                    stylingMode: "outlined",
                    onClick: (e) => { return "CONTINUE" }
                }
            ]
        });
        const result = await activateDialog.show();
        if (result === "CONTINUE") {
            this.setState({ isBusy: true }, async () => {
                try {
                    const { data: itemCount } = await actionCrud.regenerateSystemActions(this.props.contract.contractid)
                    this.props.enqueueSnackbar("System actions migration generated : " + itemCount + " items", { variant: "success" });
                    this.loadActions();
                    this.setState({ isBusy: false });
                } catch (err) {
                    this.setState({ isBusy: false });
                    this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
                }
            })
        }


    }
    deleteActionPromise = (contractid, actionids) => {
        return new Promise(async (resolve, reject) => {
            try {
                const requestObj = {
                    contractid,
                    actionids
                };
                await actionCrud.deleteAction(requestObj);
                resolve(false);
            } catch (error) {
                console.log(error);
                reject(error)
            }
        });
    }
    //deleting row
    onRowRemoving = async (e) => {
        const { contractid } = this.props.contract;
        this.gridRef.current.instance().clearSelection();
        e.cancel = this.deleteActionPromise(contractid, [e.data.actionid]);
    }
    deleteSelectedClick = async () => {
        const selection = this.gridRef.current.instance().getSelectedRowKeys();
        if (selection.length) {
            //ACCESS VALIDATION CHECKS
            const selectedItems = this.gridRef.current.instance().getSelectedRowsData();
            const invalidItem = selectedItems.find(a => (!this.validateDelete(a).allowed));
            if (invalidItem) {
                this.props.enqueueSnackbar(this.validateDelete(invalidItem).error, { variant: "error" });
                return;
            }

            let activateDialog = CustomDialog({
                title: this.props.intl.formatMessage({ id: 'ACTIONS.POPUP.BATCH_DELETE.TITLE' }, { COUNT: selection.length }), //this.props.intl.formatMessage({ id: 'GENERAL.USER_SHOWING_CONTRACT_DASHBOARD' }, { LENGTH: selection.length }),
                messageHtml: `<div style="max-width:60vw;">${this.props.intl.formatMessage({ id: 'ACTIONS.POPUP.BATCH_DELETE.MESSAGE' }, { COUNT: selection.length })}</div>`,
                buttons: [
                    {
                        text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_CANCEL" }),
                        onClick: (e) => { return "CANCEL" }
                    },
                    {
                        text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_DELETE" }),
                        type: "danger",
                        stylingMode: "outlined",
                        onClick: (e) => { return "CONTINUE" }
                    }
                ]
            });
            const result = await activateDialog.show();
            if (result === "CONTINUE") {
                const formData = {
                    actionids: selection,
                    contractid: this.props.contract.contractid
                };
                this.setState({ isBusy: true }, async () => {
                    try {
                        await actionCrud.deleteAction(formData);
                        this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "ACTIONS.TOAST.ACTIONS_DELETED" }), { variant: "success" });
                        this.gridRef.current.instance().clearSelection();
                        this.loadActions();
                    }
                    catch (err) {
                        this.setState({ isBusy: false })
                        this.props.enqueueSnackbar(err.toString(), { variant: "error" });
                    }
                })

            }
        }


    }
    completeSelectedClick = async () => {
        const selection = this.gridRef.current.instance().getSelectedRowKeys();
        if (selection.length) {
            //ACCESS VALIDATION CHECKS
            const selectedItems = this.gridRef.current.instance().getSelectedRowsData();
            const invalidItem = selectedItems.find(a => (!this.validateComplete(a).allowed));
            if (invalidItem) {
                this.props.enqueueSnackbar(this.validateComplete(invalidItem).error, { variant: "error" });
                return;
            }

            let activateDialog = CustomDialog({
                title: this.props.intl.formatMessage({ id: 'ACTIONS.POPUP.BATCH_COMPLETE.TITLE' }, { COUNT: selection.length }),
                messageHtml: `<div style="max-width:60vw;">${this.props.intl.formatMessage({ id: 'ACTIONS.POPUP.BATCH_COMPLETE.MESSAGE' }, { COUNT: selection.length })}</div>`,
                buttons: [
                    {
                        text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_CANCEL" }),
                        onClick: (e) => { return "CANCEL" }
                    },
                    {
                        text: this.props.intl.formatMessage({ id: "ACTIONS.FIELD.COMPLETE" }),
                        type: "success",
                        stylingMode: "outlined",
                        onClick: (e) => { return "CONTINUE" }
                    }
                ]
            });
            const result = await activateDialog.show();
            if (result === "CONTINUE") {
                const formData = {
                    actionids: selection,
                    contractid: this.props.contract.contractid
                };
                this.setState({ isBusy: true }, async () => {
                    try {
                        await actionCrud.complete(formData);
                        this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "ACTIONS.TOAST.ACTIONS_COMPLETED" }), { variant: "success" });
                        this.gridRef.current.instance().clearSelection();
                        this.loadActions();

                    }
                    catch (err) {
                        this.setState({ isBusy: false })
                        this.props.enqueueSnackbar(err.toString(), { variant: "error" });
                    }

                })

            }
        }
    }
    downloadExcelTemplate = async () => {
        this.importExcelTemplateDownloadLinkRef.current.click();
    }
    onSelectionChanged = ({ selectedRowKeys, component }) => {
        if (selectedRowKeys.length > 0 && selectedRowKeys.length <= 100) {
            if (this.refButtonBatchComplete) { this.refButtonBatchComplete.component.option("disabled", false); }
            if (this.refButtonBatchDelete) { this.refButtonBatchDelete.component.option("disabled", false); }
        } else {
            if (this.refButtonBatchComplete) { this.refButtonBatchComplete.component.option("disabled", true); }
            if (this.refButtonBatchDelete) { this.refButtonBatchDelete.component.option("disabled", true); }
        }
        if (selectedRowKeys.length > 0) {
            if (this.refButtonClearSelection) { this.refButtonClearSelection.component.option("disabled", false); }
        } else {
            if (this.refButtonClearSelection) { this.refButtonClearSelection.component.option("disabled", true); }
        }
        if (selectedRowKeys.length > 100) {
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "GENERAL.USER_SELECTION_LIMIT" }), { variant: "warning" });
        }
        component.refresh(true);
    }
    onExporting = (e) => {
        e.component.beginUpdate();

        const currentColumns = e.component.getVisibleColumns();
        const additionalColumnsToAdd = this.additionalColumns.filter(additionalColumn =>
            !currentColumns.some(column => column.dataField === additionalColumn.dataField)
        );

        additionalColumnsToAdd.forEach(column => {
            e.component.addColumn(column);
        });

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            customizeCell: (options) => {
                const { gridCell, excelCell } = options;
                if (gridCell.rowType === 'data') {
                    if (['url', 'delete', 'complete', 'edit'].includes(gridCell.column.dataField)) {
                        const rowData = gridCell.data;
                        if (gridCell.column.dataField === 'url') {
                            const hyperlink = this.calculateLink(rowData);
                            if (hyperlink) {
                                excelCell.value = { text: 'Link', hyperlink };
                                excelCell.font = { color: { argb: 'FF0000FF' }, underline: true };
                                excelCell.alignment = { horizontal: 'left', vertical: 'top' };
                            }
                        } else if (gridCell.column.dataField === 'delete' && this.validateDelete(gridCell.data).allowed) {
                            const hyperlink = this.calculateDeleteActionLink(rowData);
                            if (hyperlink) {
                                excelCell.value = { text: 'Link', hyperlink };
                                excelCell.font = { color: { argb: 'FF0000FF' }, underline: true };
                                excelCell.alignment = { horizontal: 'left', vertical: 'top' };
                            }
                        } else if (gridCell.column.dataField === 'complete' && this.validateComplete(gridCell.data).allowed) {
                            const hyperlink = this.calculateCompleteActionLink(rowData);
                            if (hyperlink) {
                                excelCell.value = { text: 'Link', hyperlink };
                                excelCell.font = { color: { argb: 'FF0000FF' }, underline: true };
                                excelCell.alignment = { horizontal: 'left', vertical: 'top' };
                            }
                        } else if (gridCell.column.dataField === 'edit' && this.validateEdit(gridCell.data).allowed) {
                            const hyperlink = this.calculateEditActionLink(rowData);
                            if (hyperlink) {
                                excelCell.value = { text: 'Link', hyperlink };
                                excelCell.font = { color: { argb: 'FF0000FF' }, underline: true };
                                excelCell.alignment = { horizontal: 'left', vertical: 'top' };
                            }
                        }
                    }
                }
            }
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ContractActions.xlsx');
                });
        }).finally(() => {
            additionalColumnsToAdd.forEach(column => {
                e.component.deleteColumn(column.dataField);
            });
            e.component.endUpdate();
        });

        e.cancel = true;
    }
    onBtnAddActionClicked = () => {
        this.setState({ showAddActionModal: true });
    }
    onAddActionDialogResult = (result) => {
        if (result === CreateModalResponses.SAVE) {
            this.loadActions();
        }
        this.setState({ showAddActionModal: false });
    }
    onEditActionDialogResult = (result) => {
        if (result === EditModalResponses.SAVE) {
            this.loadActions();
        }
        this.setState({ showEditActionModal: false, editingAction: null });
    }
    completeActionFromLink = async (data) => {
        let result = await completeActionConfirmationDialog(data, this.props.intl);
        
        if (result) {
            this.setState({ isBusy: true }, async () => {
                try {
                    const requestObj = {
                        contractid: this.props.contract.contractid,
                        actionids: [data.actionid]
                    }
                    const response = await actionCrud.complete(requestObj);
                    this.gridRef.current.instance().clearSelection();
                    this.loadActions();
                } catch (err) {
                    this.setState({ isBusy: false });
                    this.props.enqueueSnackbar(err.toString(), { variant: "error" });
                }
            });
        }
    }
    completeIconClicked = async (e) => {
        let result = await completeActionConfirmationDialog(e.row.data, this.props.intl);
        if (result) {
            this.setState({ isBusy: true }, async () => {
                try {
                    const requestObj = {
                        contractid: this.props.contract.contractid,
                        actionids: [e.row.data.actionid]
                    }
                    const response = await actionCrud.complete(requestObj);
                    this.gridRef.current.instance().clearSelection();
                    this.loadActions();
                } catch (err) {
                    this.setState({ isBusy: false });
                    this.props.enqueueSnackbar(err.toString(), { variant: "error" });
                }
            });
        }
    }
    editIconClicked = async (e) => {
        this.setState({ editingAction: { ...e.row.data }, showEditActionModal: true });
    }

    importFileSelected = async (e) => {
        if (e.stopPropagation) { e.stopPropagation(); }
        if (e.preventDefault) { e.preventDefault(); }
        if (e.target && e.target.files && e.target.files.length > 0) {
            var file = e.target.files[0];
            if (file) {
                this.setState({ isBusy: true }, async () => {
                    try {
                        const data = await ContractActionExcelHelper.processExcelFile(file, this.props.contract.contractid, this.props.contractTemplate.availableActionTypes);
                        const requestObj = {
                            contractid: this.props.contract.contractid,
                            actions: data
                        }
                        const { data: itemCount } = await actionCrud.importActions(requestObj)
                        if (itemCount > 0) {
                            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'ACTIONS.TOAST.IMPORTED' }, { COUNT: itemCount }), { variant: 'success', });
                        }
                        else {
                            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'ACTIONS.TOAST.IMPORTED_NONE' }), { variant: 'warning', });
                        }
                        this.loadActions();
                    } catch (err) {
                        this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
                        console.log(err.toString())
                        this.setState({ isBusy: false })
                    }
                    finally {
                        if (this.fileImportInputRef.current) {
                            this.fileImportInputRef.current.value = null;
                        }
                    }
                })

            }
        }
    }


    importExcelClicked = (e) => {
        if (this.fileImportInputRef.current) {
            this.fileImportInputRef.current.click();
        }
    }
    calculateSelectedRowSummary = (options) => {
        if (options.name === 'SelectedRowsCount') {
            if (options.summaryProcess === 'start') {
                options.totalValue = 0;
            }
            const isRowSelected = options.component.isRowSelected(options.value?.actionid);
            if (options.summaryProcess === 'calculate' && isRowSelected) {
                options.totalValue += 1;
            }
        }
    };
    validateDelete = (actionItem) => {
        let allowed = true;
        let error = "";
        if (actionItem.deleted !== 0) {
            allowed = false;
            error = this.props.intl.formatMessage({ id: "ACTIONS.ERRORS.RECORD_DELETED" });
        }
        else if (actionItem.creationsource !== 2) {
            allowed = false;
            error = this.props.intl.formatMessage({ id: "ACTIONS.ERRORS.SYSTEM_DELETE" });
        }
        else if (actionItem.completed && !listAccountsAllowedDeleteCompletedAction.includes(this.props.userProfile.accounttype)) {
            allowed = false;
            error = this.props.intl.formatMessage({ id: "ACTIONS.ERRORS.COMPLETE_DELETE" });
        }
        else if (!this.allowEdit && actionItem.createbyid !== this.props.userProfile.accountid) {
            allowed = false;
            error = this.props.intl.formatMessage({ id: "ACTIONS.ERRORS.NOT_CURRENT_USER" });
        }
        return { allowed, error }
    }
    allowDeleting = (e) => {
        return this.validateDelete(e.row.data).allowed;
    }
    validateComplete = (actionItem) => {
        let allowed = true;
        let error = "";
        if (actionItem.deleted !== 0) {
            allowed = false;
            error = this.props.intl.formatMessage({ id: "ACTIONS.ERRORS.RECORD_DELETED" });
        }
        else if (actionItem.creationsource !== 2) {
            allowed = false;
            error = this.props.intl.formatMessage({ id: "ACTIONS.ERRORS.SYSTEM_NOT_ALLOWED" });
        }
        else if (actionItem.completed) {
            allowed = false;
            error = this.props.intl.formatMessage({ id: "ACTIONS.ERRORS.COMPLETED_NOT_ALLOWED" });
        }
        return { allowed, error }
    }
    isCompleteIconVisible = (e) => {
        return this.validateComplete(e.row.data).allowed;
    }
    validateEdit = (actionItem) => {
        let allowed = true;
        let error = "";
        if (actionItem.deleted !== 0) {
            allowed = false;
            error = this.props.intl.formatMessage({ id: "ACTIONS.ERRORS.RECORD_DELETED" });
        }
        else if (actionItem.creationsource !== 2) {
            allowed = false;
            error = this.props.intl.formatMessage({ id: "ACTIONS.ERRORS.SYSTEM_NOT_ALLOWED" });
        }
        else if (!this.allowEdit && actionItem.createbyid !== this.props.userProfile.accountid) {
            allowed = false;
            error = this.props.intl.formatMessage({ id: "ACTIONS.ERRORS.NOT_CURRENT_USER" });
        }
        return { allowed, error }
    }
    isEditIconVisible = (e) => {
        return this.validateEdit(e.row.data).allowed;
    }
    renderCreateByReference = (cellInfo) => {
        const wf = this.props.contractTemplate.workflowsQA[cellInfo.data.sourceworkflowid];
        if (cellInfo.data.sourcereferenceid && cellInfo.data.sourcerecordid && wf) {
            let path = "";
            if (cellInfo.data.type === "SYSTEM_REPLY_QUOTE") {
                path = wf.paths.quotationBasePath.replace(":notificationid", cellInfo.data.sourcerecordid) + cellInfo.data.resolvingchildrecordid;
            }
            else {
                path = wf.paths.basePath + cellInfo.data.sourcerecordid;
            }
            return (
                <Link to={path}>
                    {cellInfo.data.sourcereferenceid}
                </Link>
            )

        }
        return '';
    }
    renderResolvedByReference = (cellInfo) => {
        const wf = this.props.contractTemplate.workflowsQA[cellInfo.data.resolvingworkflowid];
        if (cellInfo.data.completed && cellInfo.data.resolvingreferenceid && cellInfo.data.resolvingworkflowid && wf) {
            let path = "";
            if (cellInfo.data.resolvingchildrecordid && (cellInfo.data.type === "SYSTEM_REPLY_QUOTE" || cellInfo.data.type === "SYSTEM_COMMUNICATE_QUOTE")) {
                path = wf.paths.quotationBasePath.replace(":notificationid", cellInfo.data.resolvingrecordid) + cellInfo.data.resolvingchildrecordid;
            }
            else {
                path = wf.paths.basePath + cellInfo.data.resolvingrecordid;
            }
            return (
                <Link to={path}>
                    {cellInfo.data.resolvingreferenceid}
                </Link>
            )

        }
        return '';
    }
    calculateTypeDisplayValue = (rowData) => {
        if (rowData.resolvingworkflowid) {
            return this.props.contractTemplate.workflowsQA[rowData.resolvingworkflowid]?.pageTitle;
        }
        else {
            return this.props.contractTemplate.availableActionTypesTypeDisplayObj[rowData.type];
        }
    }
    onDatagridInitialized = (e) => {
        //DONT WANT STATE STORING TO LOAD SELECTION
        e.component.clearSelection();
    }
    onCustomFiltersChanged = (property, e) => {
        this.setState({ isBusy: true, customFilter: { ...this.state.customFilter, [property]: e.value } }, () => {
            utils.setStorage(
                customFilterStorageKey,
                JSON.stringify(this.state.customFilter),
                customFilterStoragePeriod
            );
            this.loadActions();
        });
    }
    renderToolbarSwitchArchive = () => {
        return (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ padding: 10 }}>
                    <span className="dx-button-text"><FormattedMessage id='ACTIONS.BUTTON.INCLUDE_ARCHIVED' /></span>
                </div>
                <div style={{ padding: 10 }}>
                    <Switch
                        style={{ marginLeft: 5 }}
                        defaultValue={this.state.customFilter.includeArchived}
                        onValueChanged={this.onCustomFiltersChanged.bind(this, "includeArchived")}
                        readOnly={false}
                    />
                </div>
            </div>
        )
    }
    renderToolbarSwitchDeleted = () => {
        return (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ padding: 10 }}>
                    <span className="dx-button-text"><FormattedMessage id='ACTIONS.BUTTON.INCLUDE_DELETED' /></span>
                </div>
                <div style={{ padding: 10 }}>
                    <Switch
                        style={{ marginLeft: 5 }}
                        defaultValue={this.state.customFilter.includeDeleted}
                        onValueChanged={this.onCustomFiltersChanged.bind(this, "includeDeleted")}
                        readOnly={false}
                    />
                </div>
            </div>
        )
    }
    renderToolbarSwitchCompleted = () => {
        return (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ padding: 10 }}>
                    <span className="dx-button-text"><FormattedMessage id='ACTIONS.BUTTON.INCLUDE_COMPLETED' /></span>
                </div>
                <div style={{ padding: 10 }}>
                    <Switch
                        style={{ marginLeft: 5 }}
                        defaultValue={this.state.customFilter.includeCompleted}
                        onValueChanged={this.onCustomFiltersChanged.bind(this, "includeCompleted")}
                        readOnly={false}
                    />
                </div>
            </div>
        )
    }
    onRowPrepared = (e) => {
        if (e.rowType === "data" && e.rowElement)
        {
            if(e.data?.deleted === 1){
                e.rowElement.style.backgroundColor = '#ffcccb';
            }
            else if(e.data?.completed){
                e.rowElement.style.backgroundColor = '#DFFFE9';
            }
            
        }
    }
    calculateLink = (rowData) => {
        const wf = this.props.contractTemplate.workflowsQA[rowData.sourceworkflowid];

        let url = "";

        if (rowData.sourcerecordid && wf) {
            url = process.env.PUBLIC_URL + wf.paths.basePath + rowData.sourcerecordid;
        }

        return url;
    }
    calculateDeleteActionLink = (rowData) => {
        let url = process.env.PUBLIC_URL + '/contract/' + this.props.contract.contractid + '/settings/actions?action=delete&' + 'actionid=' + rowData.actionid;

        return url;
    }
    calculateCompleteActionLink = (rowData) => {
        let url = process.env.PUBLIC_URL + '/contract/' + this.props.contract.contractid + '/settings/actions?action=complete&' + 'actionid=' + rowData.actionid;

        return url;
    }
    calculateEditActionLink = (rowData) => {
        let url = process.env.PUBLIC_URL + '/contract/' + this.props.contract.contractid + '/settings/actions?action=edit&' + 'actionid=' + rowData.actionid;

        return url;
    }
    render() {
        return (
            <Portlet isLoading={this.state.isBusy} loadingDelay={0}>
                <PortletBody >
                    <DataGrid
                        ref={this.gridRef}
                        height={'67vh'}
                        dataSource={this.state.actions}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        showBorders={true}
                        showColumnLines={true}
                        showRowLines={true}
                        remoteOperations={false}
                        allowColumnResizing={true}
                        allowColumnReordering={true}
                        columnResizingMode='widget'
                        onRowRemoving={this.onRowRemoving}
                        style={{ width: '100%', height: '100%', maxHeight: '67vh' }}
                        name="ContractActions"
                        keyExpr="actionid"
                        onSelectionChanged={this.onSelectionChanged}
                        onExporting={this.onExporting}
                        loadPanel={{ enabled: false }}
                        onInitialized={this.onDatagridInitialized}
                        onRowPrepared={this.onRowPrepared}
                    >
                        <Selection
                            mode="multiple"
                            selectAllMode="allPages"
                            showCheckBoxesMode="always"
                        />
                        <Editing
                            //CACADING FORM DEMO IMPLEMENTATION
                            //https://js.devexpress.com/Demos/WidgetsGallery/Demo/DataGrid/CascadingLookups/React/Light/
                            // mode="popup"
                            allowUpdating={false}
                            allowDeleting={this.allowDeleting}
                            allowAdding={false}
                            confirmDelete={true}
                            //https://js.devexpress.com/Documentation/ApiReference/UI_Components/dxPopup/Configuration/
                            // popup={{ title: "Add action", minWidth: 600, height: "auto", width: "auto", showTitle: true }}
                            // useIcons={true}
                            //https://js.devexpress.com/Documentation/ApiReference/UI_Components/dxDataGrid/Configuration/editing/texts/#deleteRow
                            texts={{
                                deleteRow: this.props.intl.formatMessage({ id: "GENERAL.FORMS.REMOVE" }),
                                confirmDeleteTitle: this.props.intl.formatMessage({ id: "ACTIONS.POPUP.DELETE.TITLE" }),
                                confirmDeleteMessage: this.props.intl.formatMessage({ id: "ACTIONS.POPUP.DELETE.MESSAGE" }),
                            }}

                        >
                        </Editing>
                        <HeaderFilter visible={true} />
                        <FilterPanel visible={true} />
                        <ColumnChooser enabled={true} />
                        <ColumnFixing enabled={true} />

                        {/* 
                        CREATES PROBLEMS WHEN YOU SELECT ITEMS AND REFRESH THE PAGE
                        RENDERING OF GRID HAS PROBLEMS

                        */}
                        <StateStoring
                            enabled={true}
                            type="localStorage"
                            storageKey={"FD-ActionRegister-20-" + process.env.REACT_APP_PRODUCT_KEY + process.env.REACT_APP_ENVIRONMENT}
                        />

                        <Export enabled={true} fileName={this.props.intl.formatMessage({ id: 'CONTRACT.ACTIONS.TITLE' })} />
                        <SearchPanel visible={true} highlightCaseSensitive={false} defaultText="" />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.ACTION_ID" })}
                            dataField="actionid"
                            visible={true}

                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.OWNER_PARTY" })}
                            dataField="ownerparty"
                            lookup={{ dataSource: this.props.contractTemplate.parties.options, valueExpr: 'id', displayExpr: 'display' }}
                            allowHiding={false}
                            minWidth={150}
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.TYPE" })}
                            dataField="type"
                            calculateCellValue={this.calculateTypeDisplayValue}
                            calculateDisplayValue={this.calculateTypeDisplayValue}
                        // lookup={{ dataSource: this.props.contractTemplate.availableActionTypes, valueExpr: 'value', displayExpr: 'display' }}
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.GROUP_CATEGORY" })}
                            dataField="groupcategory"
                            lookup={{ dataSource: this.actionGroupCategories, valueExpr: 'value', displayExpr: 'display' }}
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.SUBJECT" })}
                            dataField="subject"
                        />

                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.CREATE_DATE" })}
                            dataField="createdate"
                            dataType="date"
                            format={(date) => moment(date).format('DD/MM/YYYY')}
                            visible={false}
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.CREATE_BY" })}
                            dataField="createby"
                            visible={false}
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.DUE_DATE" })}
                            dataField="duedate"
                            dataType="date"
                            format={(date) => moment(date).format('DD/MM/YYYY')}
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.COMPLETED" })}
                            dataField="completed"
                        />

                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.OVERDUE" })}
                            dataField="overdue"
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.RESOLVED_DATE" })}
                            dataField="resolveddate"
                            dataType="date"
                            format={(date) => moment(date).format('DD/MM/YYYY HH:mm')}
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.RESOLVED_BY" })}
                            dataField="resolvedby"
                        />

                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.LASTEDITED_DATE" })}
                            dataField="lastediteddate"
                            dataType="date"
                            visible={false}
                            format={(date) => moment(date).format('DD/MM/YYYY HH:mm')}
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.LASTEDITED_BY" })}
                            dataField="lasteditedby"
                            visible={false}
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.CREATE_BY_REFERENCE" })}
                            dataField="sourcereferenceid"
                            cellRender={this.renderCreateByReference}
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.RESOLVED_BY_REFERENCE" })}
                            dataField="resolvingreferenceid"
                            cellRender={this.renderResolvedByReference}
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "GENERAL.WORDS.SYSTEM" })}
                            dataField="creationsource"
                            calculateCellValue={(rowData) => (rowData.creationsource === 1)}
                            width={80}
                            allowHiding={false}
                            allowReordering={false}
                            allowResizing={false}
                        />

                        <Column
                            name="editButtons"
                            type="buttons"
                            width={40}
                            allowHiding={false}
                            allowReordering={false}
                            allowResizing={false}
                        >
                            <Button icon="trash" name="delete" />
                        </Column>
                        <Column
                            name="completeButton"
                            type="buttons"
                            width={40}
                            allowHiding={false}
                            allowReordering={false}
                            allowResizing={false}
                        >
                            <Button
                                name="complete"
                                hint={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.COMPLETE" })}
                                icon="check"
                                visible={this.isCompleteIconVisible}
                                disabled={false}
                                onClick={this.completeIconClicked}
                            />
                        </Column>
                        <Column
                            name="editButton"
                            type="buttons"
                            width={40}
                            allowHiding={false}
                            allowReordering={false}
                            allowResizing={false}
                        >
                            <Button
                                name="edit"
                                hint={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.EDIT" })}
                                icon="edit"
                                visible={this.isEditIconVisible}
                                disabled={false}
                                onClick={this.editIconClicked}
                            />
                        </Column>

                        <Scrolling mode="virtual" showScrollbar={true} useNative={true} columnRenderingMode="virtual" rowRenderingMode="virtual" />
                        <Toolbar>
                            <ToolbarItem location="before">
                                <div>
                                    <h3 style={{ fontFamily: SystemHelper.getThemeTextFont() ?? 'Poppins, Helvetica, sans-serif', fontSize: '1.2rem', fontWeight: 500, color: '#48465b', padding: 0, margin: 0, lineHeight: 1.2 }} className="kt-portlet__head-title">
                                        <FormattedMessage id='ACTIONS.TITLE' />
                                    </h3>
                                </div>
                            </ToolbarItem>


                            <ToolbarItem location="after"
                                locateInMenu="auto"
                                name="addAction"
                                showText="always"
                                widget="dxButton"
                                options={{
                                    icon: "plus",
                                    text: this.props.intl.formatMessage({ id: "ACTIONS.BUTTON.ADD_ACTION" }),
                                    onClick: this.onBtnAddActionClicked,
                                }}
                            />
                            <ToolbarItem
                                location="after"
                                locateInMenu="auto"
                                widget="dxButton"
                                options={{
                                    onInitialized: (e) => { this.refButtonBatchDelete = e; },
                                    icon: "trash",
                                    text: this.props.intl.formatMessage({ id: "ACTIONS.BUTTON.DELETE_ACTIONS" }),
                                    disabled: true,
                                    onClick: this.deleteSelectedClick,
                                    type: "danger",
                                    stylingMode: "outlined",
                                }}
                            />
                            <ToolbarItem
                                location="after"
                                locateInMenu="auto"
                                widget="dxButton"
                                options={{
                                    onInitialized: (e) => { this.refButtonBatchComplete = e; },
                                    icon: "check",
                                    text: this.props.intl.formatMessage({ id: "ACTIONS.BUTTON.COMPLETE_ACTIONS" }),
                                    disabled: true,
                                    onClick: this.completeSelectedClick,
                                    type: "success",
                                    stylingMode: "outlined",
                                }}
                            />
                            <ToolbarItem
                                location="after"
                                locateInMenu="auto"
                                widget="dxButton"
                                options={{
                                    onInitialized: (e) => { this.refButtonClearSelection = e; },
                                    icon: "clear",
                                    text: this.props.intl.formatMessage({ id: "ACTIONS.BUTTON.CLEAR_SELECTION" }),
                                    disabled: true,
                                    onClick: () => this.gridRef.current.instance().clearSelection()
                                }}
                            />
                            <ToolbarItem
                                location="after"
                                locateInMenu="always"
                                widget="dxButton"
                                options={{
                                    icon: "download",
                                    text: this.props.intl.formatMessage({ id: "ACTIONS.BUTTON.DOWNLOAD_EXCEL_TEMPLATE" }),
                                    onClick: this.downloadExcelTemplate,
                                }}
                            />
                            <ToolbarItem
                                location="after"
                                locateInMenu="auto"
                                widget="dxButton"
                                options={{
                                    icon: "import",
                                    text: this.props.intl.formatMessage({ id: "ACTIONS.BUTTON.IMPORT_FROM_EXCEL" }),
                                    onClick: this.importExcelClicked,
                                }}
                            />
                            <ToolbarItem
                                location="after"
                                locateInMenu="always"
                                widget="dxButton"
                                options={{
                                    icon: "refresh",
                                    text: this.props.intl.formatMessage({ id: "GENERAL.BUTTON.REFRESH" }),
                                    onClick: this.loadActions,
                                }}
                            />
                            {
                                this.props.userProfile.accounttype === "System Owner" && (
                                    <ToolbarItem
                                        location="after"
                                        locateInMenu="always"
                                        widget="dxButton"
                                        options={{
                                            icon: "deletetable",
                                            type: "danger",
                                            stylingMode: "outlined",
                                            text: "Regenerate System Actions",
                                            onClick: this.regenerateSystemActions,
                                        }}
                                    />
                                )
                            }
                            <ToolbarItem
                                location="after"
                                locateInMenu="always"
                                render={this.renderToolbarSwitchArchive}
                            />
                            <ToolbarItem
                                location="after"
                                locateInMenu="always"
                                render={this.renderToolbarSwitchDeleted}
                            />
                            <ToolbarItem
                                location="after"
                                locateInMenu="always"
                                render={this.renderToolbarSwitchCompleted}
                            />
                            <ToolbarItem location="after"
                                locateInMenu="auto"
                                name="exportButton"
                            />
                            <ToolbarItem location="after"
                                locateInMenu="auto"
                                name="applyFilterButton"
                            />
                            <ToolbarItem location="after"
                                locateInMenu="auto"
                                name="columnChooserButton"
                            />
                            <ToolbarItem location="after"
                                locateInMenu="auto"
                                name="searchPanel"
                            />
                        </Toolbar>
                        <Summary
                            calculateCustomSummary={this.calculateSelectedRowSummary}
                            recalculateWhileEditing={true}
                        >
                            <TotalItem
                                name="SelectedRowsCount"
                                summaryType="custom"
                                // valueFormat="currency"
                                displayFormat={this.props.intl.formatMessage({ id: "ACTIONS.LABEL.SELECTED_COUNT" })}
                                showInColumn="ownerparty"
                            // column={1}
                            />

                        </Summary>
                    </DataGrid>
                </PortletBody>
                <ContractActionCreateModal
                    visible={this.state.showAddActionModal}
                    allowRecurrent={true}
                    onDialogResult={this.onAddActionDialogResult}
                />
                <ContractActionEditModal
                    visible={this.state.showEditActionModal}
                    action={this.state.editingAction}
                    onDialogResult={this.onEditActionDialogResult}
                />
                <a ref={this.importExcelTemplateDownloadLinkRef} href={process.env.PUBLIC_URL + '/files/ContractActionsImportTemplate.xlsx'} download="Contract Actions Import Template"></a>
                <input type='file' id='importFile' accept='.xlsx' ref={this.fileImportInputRef} style={{ display: 'none' }} onChange={this.importFileSelected} />
            </Portlet>
        );
    }
}

const mapStateToProps = store => ({
    contract: store.contract.contract,
    contractTemplate: store.contract.template,
    userProfile: store.auth.userProfile
});



export default injectIntl(withRouter(withSnackbar(connect(mapStateToProps)(ContractActions))));
